import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _mapInstanceProperty from "core-js-pure/stable/instance/map.js";
import _Object$keys from "core-js-pure/stable/object/keys.js";
import _spliceInstanceProperty from "core-js-pure/stable/instance/splice.js";
import _concatInstanceProperty from "core-js-pure/stable/instance/concat.js";
import _sliceInstanceProperty from "core-js-pure/stable/instance/slice.js";
import _indexOfInstanceProperty from "core-js-pure/stable/instance/index-of.js";
import _parseFloat from "core-js-pure/stable/parse-float.js";

/*
 * @Author: Song Yunlu
 * @Date:   2018-04-08
 * @Last Modified by: zhangrongmou
 * @Last Modified time: 2018-06-25 11:15:30
 */
export function numberToChinese(num) {
  var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; // var chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];

  var chnUnitChar = ['', '十', '百', '千'];
  var strIns = '';
  var chnStr = '';
  var unitPos = 0;
  var zero = true;

  if (num === 0) {
    return chnNumChar[0];
  }

  while (num > 0) {
    var v = num % 10;

    if (v === 0) {
      if (!zero) {
        zero = true;
        chnStr = chnNumChar[v] + chnStr;
      }
    } else {
      zero = false;
      strIns = chnNumChar[v];
      strIns += chnUnitChar[unitPos];
      chnStr = strIns + chnStr;
    }

    unitPos++;
    num = Math.floor(num / 10);
  }

  return chnStr;
}
/**
 * Merge defaults with user options
 * @param {Object} defaults Default settings
 * @param {Object} options User options
 * @returns {Object} Merged values of defaults and options
 */

export function extend(defaults, options) {
  var extended = {};
  var prop;

  for (prop in defaults) {
    if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
      extended[prop] = defaults[prop];
    }
  }

  for (prop in options) {
    if (Object.prototype.hasOwnProperty.call(options, prop)) {
      extended[prop] = options[prop];
    }
  }

  return extended;
}
/*
* 比较版本号
* @param  {string} source 比较源
* @param  {string} target 比较目标
* @return {inter} 前者大返回>0, 相等返回0, 前者小返回<0
*/

export function compareAppVersion(source, target) {
  var sourceArr = source.split('.');
  var targetArr = target.split('.');

  for (var i = 0; i < targetArr.length; i++) {
    if (sourceArr[i] !== targetArr[i]) {
      sourceArr[i] = isNaN(sourceArr[i]) ? 0 : sourceArr[i];
      targetArr[i] = isNaN(targetArr[i]) ? 0 : targetArr[i];
      return sourceArr[i] - targetArr[i];
    }
  }

  return 0;
}
/**
* val版本号 大于等于 基准版本号
* @param  {string} val  现在的值
* @param  {string} base 基准
* @return {inter}
*/

export function isGteVersion(val, base) {
  return compareAppVersion(val, base) >= 0;
}
/**
 *  分-》元
 *  @param  {number} fen  数量分
 */

export function priceFormat(fen) {
  fen = fen || 0;
  return Math.floor(fen / 100) + '.' + fen % 100;
}
export function secondsFormat(seconds) {
  var minute = Math.floor(seconds / 60);
  var second = seconds % 60;
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return minute + ':' + second;
}
/**
 * eg: file timestamp-》3天3小时5分钟
 * @param  {number} timestamp 时间戳
 * @return {string}
 */

export function deadLineFormat(timestamp) {
  var now = new Date();
  var diff = Math.floor((timestamp - now) / 1000 / 60);
  var days = Math.floor(diff / 60 / 24);
  var hours = Math.floor((diff - days * 24 * 60) / 60);
  var minutes = diff % 60;
  var result = '';

  if (days) {
    result = days + '天';
  }

  if (hours) {
    result += hours + '小时';
  }

  if (minutes) {
    result += minutes + '分钟';
  }

  return result;
}
/**
 *
 *
 * 格式化金额 千分位分割
 * @param {number, string} money
 * @return {string}
 */

export function moneyFormat(money) {
  if (!money) {
    return '0.00';
  }

  return money.toString().replace(/\d+/, function (s) {
    return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  });
}
export function trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '');
}
export function htmlspecialchars(str) {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
  };
  return str.replace(/[&<>"']/g, function (m) {
    return map[m];
  });
}
/**
 * 深拷贝
 * @param {*} obj
 * @return {*} newObj
 */

export function deepClone(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    return obj;
  }

  var newObj = {};

  if (Array.isArray(obj)) {
    newObj = _mapInstanceProperty(obj).call(obj, function (item) {
      return deepClone(item);
    });
  } else {
    _Object$keys(obj).forEach(function (key) {
      newObj[key] = deepClone(obj[key]);
    });
  }

  return newObj;
} // 不完整的模拟node util.format

export function _format() {
  var target = arguments[0];

  if (!target || typeof target !== 'string') {
    return target;
  }

  var replacer = _spliceInstanceProperty([]).call(arguments, 1);

  var index = 0;
  return target.replace(/(%s)/g, function () {
    return typeof replacer[index] !== 'undefined' ? replacer[index++] : arguments[0];
  });
} // 昵称过长中间部分用...表示

export function formatName(name) {
  if (name.length > 8) {
    var _context;

    return _concatInstanceProperty(_context = "".concat(_sliceInstanceProperty(name).call(name, 0, 3), "...")).call(_context, _sliceInstanceProperty(name).call(name, -2));
  }

  return name;
}
/**
 * 格式化多语言包的文案，兼容%s 和 ${}
 *
 * @param {any} args
 * @returns
 * 使用说明:
 * args[1], args[2]... 分别替换 ${0} ${1}...的内容，所有的 %s 将被替换成args[1]
 * 使用示例:
 * targetStr = '最低提取 ¥${0}, 每月可提现${1}次, 最高提取 ¥%s';
 * formatLanguage(targetStr, 20, 2) => '最低提取 ¥20 , 每月可提现2次, 最高提取 ¥20'
 */

export function formatLanguage() {
  var args = arguments;
  var targetStr = args[0];

  if (!targetStr) {
    return '';
  }

  if (-1 !== _indexOfInstanceProperty(targetStr).call(targetStr, '%s')) {
    targetStr = _format.apply(null, args);
  }

  for (var i = 1; i < args.length; i++) {
    var replacement = '${' + (i - 1) + '}';

    if (-1 !== _indexOfInstanceProperty(targetStr).call(targetStr, replacement)) {
      // args[1] 对应的是 ${0}, args[2] 对应的是 ${1}, 依次类推
      // 把所有%s全部替换为args[1]，依次类推
      targetStr = targetStr.split(replacement).join(args[i]);
    }
  }

  return targetStr;
}
/**
 * 倒计时模块
 * @param  {Number}   seconds            倒计时时间
 * @param  {Function} startCallback   开始时的回调函数
 * @param  {Function} progressCallback   进行时的回调函数，每个1s执行一次
 * @param  {Function} endCallback        结束后的回调函数
 */

export function countDown(_ref) {
  var _ref$seconds = _ref.seconds,
      seconds = _ref$seconds === void 0 ? 60 : _ref$seconds,
      startCallback = _ref.startCallback,
      progressCallback = _ref.progressCallback,
      endCallback = _ref.endCallback;
  var countDownTimer;
  startCallback && startCallback(seconds);

  function loopCheck() {
    seconds--;

    if (seconds >= 0) {
      countDownTimer = setTimeout(function () {
        progressCallback && progressCallback(seconds);
        loopCheck();
      }, 1000);
    } else {
      endCallback && endCallback();
    }
  }

  loopCheck();
  return {
    stop: function stop() {
      clearTimeout(countDownTimer);
    }
  };
}
/**
* 手机号检查工具
* @param  {String}  val 手机号
* @return {Boolean}     结果
*/

export function isInvalidMobile(val) {
  return !/^1\d{10}$/.test(val);
}
export function isValidChineseName(val) {
  // 中文姓名正则（包含少数民族姓名和生僻字姓名）https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=260058309
  var CHINESE_NAME_REG = /^(?:[\u4E00-\u9FEF]|\u3007|[\u3400-\u4DB5]|[\uF900-\uFAD9]|(?:[\uD840-\uD87A][\uDC00-\uDFFF])|(?:\uD87E[\uDC00-\uDE1D])){2,}(?:·(?:[\u4E00-\u9FEF]|\u3007|[\u3400-\u4DB5]|[\uF900-\uFAD9]|(?:[\uD840-\uD87A][\uDC00-\uDFFF])|(?:\uD87E[\uDC00-\uDE1D])){2,})*$/; // eslint-disable-line

  return CHINESE_NAME_REG.test(val);
}
/*
 * 给定一个以元为单位的金额数值，把它转化成以分为单位的数值
 * @param  { Number }  val 金额（元）
 * @return { Number }  金额（分）
 */

export function yuanToFen(val) {
  if (typeof val !== 'number' || isNaN(val) || !isFinite(val)) {
    return 0;
  }

  var result = Math.round(val * 100);

  if (!isFinite(result)) {
    return 0;
  }

  return result;
} // 对浮点误差容忍的floor

export function safeFloor(val) {
  return Math.floor(val + 1e-5);
}
/*
 * 给定一个金额数值，把它转化成以元为单位的字符串形式
 * @param  { Number }  val 金额（分）
 * @param  { Object }  opts
 *      @param { Boolean } trimTrailingZeros 是否截取末尾的零
 *      @param { Boolean } addComma          是否增加千位分隔符(半角逗号) 1,234,567.89
 * @return { String }  金额（元）
 */

export function fenToYuan(val) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof val !== 'number' || isNaN(val) || !isFinite(val)) {
    return '';
  }

  var yuanVal = (val / 100).toFixed(2);

  if (opts.trimTrailingZeros) {
    if (yuanVal[yuanVal.length - 1] === '0') {
      yuanVal = _sliceInstanceProperty(yuanVal).call(yuanVal, 0, -1);

      if (yuanVal[yuanVal.length - 1] === '0') {
        yuanVal = _sliceInstanceProperty(yuanVal).call(yuanVal, 0, -2);
      }
    }
  } // 增加千位分隔符(半角逗号)


  if (opts.addComma) {
    var _context2, _context3;

    var result = [];
    var minus = val < 0 ? '-' : '';

    if (minus) {
      yuanVal = yuanVal.replace('-', '');
    }

    var _yuanVal$split = yuanVal.split('.'),
        _yuanVal$split2 = _slicedToArray(_yuanVal$split, 2),
        _yuanVal$split2$ = _yuanVal$split2[0],
        yuan = _yuanVal$split2$ === void 0 ? '' : _yuanVal$split2$,
        _yuanVal$split2$2 = _yuanVal$split2[1],
        fen = _yuanVal$split2$2 === void 0 ? '' : _yuanVal$split2$2;

    while (yuan.length) {
      result.unshift(yuan.substring(yuan.length - 3));
      yuan = yuan.substring(0, yuan.length - 3);
    }

    yuanVal = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(minus)).call(_context3, result.join(','), ".")).call(_context2, fen);
  }

  return yuanVal;
}
/**
 * localStroage封装
 */

export var ls = {
  getItem: function getItem(key) {
    if (window.localStorage) {
      return window.localStorage.getItem(key);
    }

    return '';
  },
  setItem: function setItem(key, value) {
    if (window.localStorage) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {
        console.log(e); // eslint-disable-line
      }
    }
  }
};
export function isValidIdCardNo(val) {
  if (!val) {
    return false;
  } // 允许身份证最后一位是小写x


  var code = val.toUpperCase();
  var pass = true;

  if (!code || !/(^\d{15}$)|(^\d{17}(\d|X|x)$)/i.test(code)) {
    pass = false;
  } else if (code.length === 18) {
    code = code.split('');
    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    var ai = 0;
    var wi = 0;

    for (var i = 0; i < 17; i++) {
      ai = code[i];
      wi = factor[i];
      sum += ai * wi;
    }

    if (parity[sum % 11].toString() !== code[17].toString()) {
      pass = false;
    }
  }

  return pass;
}
/*
 * 给定一个以分为单位的金额数值，大于10000，转换为带万字，最多保留两位万以下数值
 * @param  { Number }  val 金额（分）
 */

export function parseMinAndMaxWithdraw(withdrawFen) {
  withdrawFen = Number(withdrawFen);

  if (typeof withdrawFen !== 'number') {
    return;
  }

  if (withdrawFen < 1000000) {
    return Math.floor(withdrawFen / 100);
  }

  return _parseFloat((withdrawFen / 1000000).toFixed(2)) + '万';
}
export function symbolifyNumber(num) {
  var pur_number = 0;

  if (typeof num === 'string') {
    pur_number = num.split(',').join('');
  } else {
    pur_number = num;
  }

  return +pur_number > 0 ? "+".concat(num) : "".concat(num);
}